import { useTranslation } from "react-i18next";
import { components } from "react-select";

const RepairReasonOption = (props) => {
  const { t } = useTranslation("common");

  const handleEditClick = (e) => {
    e.stopPropagation();
    if (props.setTempRepairReasonData && props.setShowRepairReasonPopup) {
      props.setTempRepairReasonData({ ...props.data, __isNew__: false });
      props.setShowRepairReasonPopup(true);
    }
  };

  if (props.data.__isNew__) {
    return (
      <>
        <hr style={{ margin: 0, padding: 0 }} />
        <components.Option {...props}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <span
              style={{ color: "#007bff", fontWeight: 300, fontSize: "12px" }}
            >
              {t("create_new_repair_reason")}
              <span style={{ fontWeight: 500 }}> "{props.data.value}"</span>
            </span>
          </div>
        </components.Option>
      </>
    );
  }

  return (
    <components.Option {...props}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <span style={{ flex: 1 }}>{props.data.label}</span>
        <i
          className="fi fi-rr-pencil"
          style={{
            cursor: "pointer",
            color: "#6c757d",
            marginLeft: "8px",
            fontSize: "14px",
          }}
          onClick={handleEditClick}
          onMouseEnter={(e) => {
            e.target.style.color = "#495057";
          }}
          onMouseLeave={(e) => {
            e.target.style.color = "#6c757d";
          }}
        />
      </div>
    </components.Option>
  );
};

export default RepairReasonOption;
